import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export class Navigation {
  constructor() {
    this.open = false
    this.toggle = document.querySelectorAll('[data-toggle-nav]')

    this.toggle.forEach((button) => {
      button.addEventListener('click', () => {
        this.open ? this.closeNavigation() : this.openNavigation()
      })
    })

    this.handleSubMenu()
    this.setActiveState()
		this.pinNavigation()
  }
  openNavigation() {
    this.open = true
    document.documentElement.classList.add('nav-open')
  }
  closeNavigation() {
    this.open = false
    document.documentElement.classList.remove('nav-open')
  }
  snapCloseNavigation() {}
  setActiveState() {
    const url = window.location.href
    const menuItems = document.querySelectorAll('.menu-item a')

    menuItems.forEach((item) => {
      item.parentElement.classList.remove('current-menu-item')
      if (item.href == url) {
        item.parentElement.classList.add('current-menu-item')
      }
    })
  }
  handleSubMenu() {
    const links = document.querySelectorAll('.menu-item-has-children > a')

    links.forEach((link) => {
      let isOpen = false

      link.addEventListener('click', (e) => {
        e.preventDefault()
        const openSubmenu = () => {
          e.target.parentElement.classList.add('sub-menu-open')
        }
        const closeSubmenu = () => {
          e.target.parentElement.classList.remove('sub-menu-open')
        }
        isOpen ? closeSubmenu() : openSubmenu()
        isOpen = !isOpen
      })
    })
  }
	pinNavigation() {
		const nav = document.querySelector('.header__nav')
		const end = document.querySelector('body')

		if (window.innerWidth < 650) return

		gsap.timeline({
			scrollTrigger: {
				trigger: nav,
				endTrigger: end,
				pin: true,
				start: 'top top',
				end: `bottom bottom`
			}
		})
	}
}

export default () => {}

new Navigation()
